module.exports = __webpack_public_path__ + "static/media/team3.56a1123c.png";